import { Zap } from "lucide-react";

/**
 * Small "Self-Paced" badge shown on course cards / headers when a course
 * offers a self-paced delivery format (Self-Study or E-Learning).
 * Use to highlight flexible learning options at a glance across the catalog.
 */
export const isSelfPaced = (course) =>
  !!course?.delivery_formats?.some(
    (f) => f?.format === "e-learning" || f?.format === "self-study"
  );

export const SelfPacedBadge = ({ course, className = "", size = "sm" }) => {
  if (!isSelfPaced(course)) return null;
  const padding = size === "md" ? "px-2.5 py-1" : "px-2 py-0.5";
  const textSize = size === "md" ? "text-xs" : "text-[10px]";
  return (
    <span
      data-testid={`self-paced-badge-${course.id}`}
      className={`inline-flex items-center gap-1 ${padding} ${textSize} font-semibold rounded-full bg-brand/10 text-brand border border-brand/20 ${className}`}
      title="Available as Self-Paced E-Learning"
    >
      <Zap className="h-3 w-3" />
      Self-Paced
    </span>
  );
};

export default SelfPacedBadge;
